/**
 * Shared Recharts style tokens, keyed by admin theme.
 * Recharts props are plain SVG attributes, not CSS classes, so they can't
 * pick up the --nhp-* CSS variables automatically — callers pass the current
 * theme from useAdminTheme() to getChartTheme() and read values off the
 * returned object.
 */
const PALETTES = {
  dark: {
    gridStroke: "#1E2330",
    tick: { fill: "#8B949E", fontSize: 10, fontFamily: "IBM Plex Mono" },
    tickLg: { fill: "#8B949E", fontSize: 11 },
    axisLine: { stroke: "#1E2330" },
    tooltip: { background: "#12141A", border: "1px solid #1E2330", fontFamily: "IBM Plex Mono", fontSize: 12 },
    tooltipLabel: { color: "#8B949E" },
    tooltipItem: { color: "#00E676" },
    tooltipCursor: { fill: "#1E2330" },
    accent: "#00E676",
  },
  light: {
    gridStroke: "#DCE0DC",
    tick: { fill: "#5B645C", fontSize: 10, fontFamily: "IBM Plex Mono" },
    tickLg: { fill: "#5B645C", fontSize: 11 },
    axisLine: { stroke: "#DCE0DC" },
    tooltip: { background: "#FFFFFF", border: "1px solid #DCE0DC", fontFamily: "IBM Plex Mono", fontSize: 12 },
    tooltipLabel: { color: "#5B645C" },
    tooltipItem: { color: "#1E8E4A" },
    tooltipCursor: { fill: "#F4F5F4" },
    accent: "#1E8E4A",
  },
};

export function getChartTheme(theme) {
  return PALETTES[theme] || PALETTES.dark;
}
